const autoNgTemplateLoaderTemplate1 = require('./resourcePoolApplicationsDatatable.html');

angular.module('portainer.kubernetes').component('kubernetesResourcePoolApplicationsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesResourcePoolApplicationsDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    refreshCallback: '<',
  },
});
